import { Link } from 'react-router-dom';
import type { NewsArticle } from '@/types/news';
import NewsCard from '@/components/base/NewsCard';

interface HotListProps {
  articles: NewsArticle[];
}

export default function HotList({ articles }: HotListProps) {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="mb-2 flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
          <i className="ri-fire-fill text-secondary-500" />
          热门推荐
        </h2>
        <span className="text-xs text-foreground-500">编辑精选</span>
      </div>
      <div>
        {articles.map((article, i) => (
          <NewsCard key={article.id} article={article} variant="compact" rank={i + 1} />
        ))}
      </div>
      <Link
        to="/category/society"
        className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700"
      >
        查看更多爆料
        <i className="ri-arrow-right-line" />
      </Link>
    </section>
  );
}